'use client';

import { BaseTranslations } from '../../../baseTranslations';
import { useCmsClientContext } from '../../../utils/cmsPageContext';
import { groupProductAttributes } from '../../../utils/helpers';
import { getClientTranslations } from '../../../utils/translations/getClientTranslations';
import { tr } from '../../../utils/translations/tr';
import { MaterialIcon } from '../../MaterialIcon';
import { ProductDetailsAttributeList } from '../BaseComponents/ProductDetailsAttributeList';
import { ProductDetailsSectionHeader } from '../BaseComponents/ProductDetailsSectionHeader';
import { ProductDetailsProps } from '../ProductDetails';

export const ProductDetailsSectionBenefits: React.FC<ProductDetailsProps> = (
  props,
) => {
  const { product, benefitCategorySelector, pushDataLayer } = props;

  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);

  const { benefitsAirmiles, benefitsRewardsPoints, benefitsCashback } =
    groupProductAttributes(product);

  const showCashback =
    !!benefitsCashback?.length &&
    !!benefitCategorySelector?.includes('CASHBACK');
  const showAirmiles =
    !!benefitsAirmiles?.length &&
    !!benefitCategorySelector?.includes('AIRMILES');
  const showRewardsPoints =
    !!benefitsRewardsPoints?.length &&
    !!benefitCategorySelector?.includes('REWARDS_POINTS');

  const sectionTitle = tr('pd_nav_benefits', staticText);

  return (
    <div className="flex flex-col gap-6">
      <ProductDetailsSectionHeader
        icon={<MaterialIcon icon="thumb_up" size={3} />}
      >
        {sectionTitle}
      </ProductDetailsSectionHeader>

      {showCashback && (
        <ProductDetailsAttributeList
          attributes={benefitsCashback!}
          title={tr('cashback', staticText)}
          sectionTitle={sectionTitle}
          dropdownSection={true}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      )}

      {showAirmiles && (
        <ProductDetailsAttributeList
          attributes={benefitsAirmiles!}
          title={tr('airmiles', staticText)}
          sectionTitle={sectionTitle}
          dropdownSection={true}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      )}

      {showRewardsPoints && (
        <ProductDetailsAttributeList
          attributes={benefitsRewardsPoints!}
          title={tr('rewards_points', staticText)}
          sectionTitle={sectionTitle}
          dropdownSection={true}
          product={product}
          pushDataLayer={pushDataLayer}
        />
      )}
    </div>
  );
};
